// extracted by mini-css-extract-plugin
export default {"container":"container--Ktyh1","icon":"icon--MdXtS","title":"title--RiNS1","text":"text--N0Aco"};